<script setup lang="ts">
import Logo from '@/assets/cart-logo.svg?component'
import Shield from '@/assets/shield.svg?component'
import Headphones from '@/assets/headphones.svg?component'

const store = useStore()
const { tel, shopInformation } = storeToRefs(store)
</script>

<template>
  <NuxtLoadingIndicator color="#ce1f40" />
  <div class="lg:min-h-screen flex flex-col">
    <div class="sticky top-0 w-full bg-green z-10">
      <div class="container py-[5px] lg:py-[11px] lg:mx-auto flex items-center">
        <NuxtLink to="/">
          <Logo class="fill-white" />
        </NuxtLink>
        <div class="flex-1 text-right text-white text-12 px-[10px]">
          Jesteś w bezpiecznej strefie zakupów
        </div>
        <Shield />
      </div>
    </div>
    <div class="w-full flex-1">
      <slot />
    </div>
    <div class="w-full mt-[30px]">
      <div class="container mx-auto">
        <div class="grid grid-rows-3 lg:grid-rows-1 lg:grid-cols-3 gap-y-[10px] lg:px-[70px] py-[10px] lg:py-[20px] border-b border-b-gray-400 lg:border-t lg:border-t-gray-400">
          <div class="flex flex-col w-full">
            <span class="font-medium">Masz pytania?</span>
            <span>Będziemy szczęśliwi, mogąc Ci pomóc.</span>
          </div>
          <div class="flex lg:justify-center w-full">
            <NuxtLink :href="tel" class="flex items-center gap-[10px]">
              <Headphones />
              {{ shopInformation.shopInformation.phone }}
            </NuxtLink>
          </div>
          <div class="inline-flex flex-col justify-self-end lg:flex-row lg:items-center justify-around w-full">
            <NuxtLink to="/i/regulamin">
              Regulamin
            </NuxtLink>
            <NuxtLink to="/i/polityka-prywatnosci">
              Polityka prywatności
            </NuxtLink>
          </div>
        </div>
        <p class="flex flex-col items-center mt-[10px] lg:mb-[20px]">
          <small>2009-{{ new Date().getFullYear() }} Copyright © {{ shopInformation.shopInformation.shopName }}</small>
          <small>Wszelkie prawa zastrzeżone.</small>
        </p>
      </div>
    </div> 
  </div>
</template>